import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 17H11C11 17 6 17 6 12M18 7H11C11 7 6 7 6 12M6 12H17",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIn;
